import { render, staticRenderFns } from "./videoCam.vue?vue&type=template&id=5957beaa"
import script from "./videoCam.vue?vue&type=script&lang=js"
export * from "./videoCam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports